
import './actionButtons.css';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import logger from '../../../../utils/logger';



const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05
    }
  }
};

const buttonVariants = {
  hidden: { opacity: 0, x: 50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.4 }
  }
};


export const ActionButtons = ({ dropdown, usersData, handleObject }) => {

  const [openIndex, setOpenIndex] = useState(null)
  const [arrayBtn, setArrayBtn] = useState([])
  const [activeIndex, setActiveIndex] = useState(0)


  logger.info('activeIndex: ', activeIndex)

  function newApiCounter(array) {
    return array.map((btn) => {
      switch (btn.status) {
        case 'Todos':
          return {
            ...btn,
            icon: 'groups_2',
            spanClass: 'material-icons mI-todos notranslate'
          }

        case 'Habilitados':
          return {
            ...btn,
            icon: 'check_circle',
            spanClass: 'material-icons mI-habilitados notranslate',
            dropMenu: [
              {item: 'Activos', label: 'Activos'},
              {item: 'PorVencer', label: 'Por Vencer'},
              {item: 'Divider'},
              {item: 'Habilitados', label: 'Todos'},      
            ]

          }

        case 'Inscriptos':
          return {
            ...btn,
            icon: 'clock_loader_60',
            spanClass: 'material-symbols-outlined mI-interesados notranslate',
            dropMenu: [
              {item: 'Interesados', label: 'Interesados'},
              {item: 'Pendientes', label: 'Pendientes'},
              {item: 'Divider'},
              {item: 'Inscriptos', label: 'Todos'},
              
            ]
          }

        case 'Inactivos':
          return {
            ...btn,
            icon: 'person_off',
            spanClass: 'material-icons mI-inactivos notranslate',
            dropMenu: [
              {item: 'Vencidos', label: 'Vencidos'},
              {item: 'Deshabilitados', label: 'Deshabilitados'},
              {item: 'Rechazados', label: 'Rechazados'},
              {item: 'Divider'},
              {item: 'Inactivos', label: 'Todos'},
            
            ]
          }

        default:
          return btn
      }
    })
  }


  useEffect(() => {
    if (usersData && usersData.counters) {
      const arrayConstructor = newApiCounter(usersData.counters)
      setArrayBtn(arrayConstructor)
      logger.info('arrayConstructor: ', arrayConstructor)
      logger.info('usersData: ', usersData.counters)
    }

  }, [usersData])


  const handleFetch = (params) => {

    const request = {
      Status: params,
      // Dni: "",
      // Email: "",
      // FormationPlaceId: "",
      // LastName: "",
      // Name: "",
    }

    handleObject(request)
  }


  return (
    <motion.div
      className="container container-buttons"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="row filter-buttons">

        {arrayBtn.length > 0 ? arrayBtn.map((btn, index) => (

          <motion.div
            key={index}
            className={`col-6 col-md-3 cont-Fbtn${index + 1}`}
            variants={buttonVariants}
          >

            {dropdown && btn.dropMenu ?

              <Dropdown className="btn-group btn-group-style" show={openIndex === index} onToggle={(isOpen) => setOpenIndex(isOpen ? index : null)}>

                <button
                  className={`filter-btns  ${index === activeIndex ? "filter-btns-selected" : ""} ${btn.dropMenu ? 'fbtn-border' : ""}`}
                  onClick={() => {
                    handleFetch(btn.status);
                    setActiveIndex(index)

                  }}
                  index={index}
                >
                  <p className="f-btn-title">{btn.status}</p>
                  <div className="f-btn-container">
                    <p>{btn.count}</p>
                    <span className={`${btn.spanClass}`}>
                      {btn.icon}
                    </span>
                  </div>
                </button>


                <Dropdown.Toggle
                  split
                  variant="secondary"
                  className="btn btn-lg btn-secondary  dropdown-toggle dropdown-toggle-split"
                  id={`dropdown-split-${index}`}
                />


                <Dropdown.Menu align="end" onClick={() => setActiveIndex(index)}>
                  {
                    btn.dropMenu ? btn.dropMenu.map((item, index) =>
                      item.item === 'Divider' ? (
                        <Dropdown.Divider key={`divider-${index}`} />
                      ) : (
                        <Dropdown.Item
                          key={`item-${index}`}
                          onClick={() => handleFetch(item.item)}
                        >{item.label}</Dropdown.Item>
                      )
                    )
                      :
                      null
                  }
                </Dropdown.Menu>
              </Dropdown>
              :

              <button
                className={`filter-btns  ${index === activeIndex ? "filter-btns-selected" : ""} `}
                onClick={() => {
                  handleFetch(btn.status);
                  setActiveIndex(index)

                }}>
                <p className="f-btn-title">{btn.status}</p>
                <div className="f-btn-container">
                  <p>{btn.count}</p>
                  <span className={`${btn.spanClass}`}>
                    {btn.icon}
                  </span>
                </div>
              </button>



            }


          </motion.div>



        ))
          : null
        }
      </div>
    </motion.div>
  );
};
